import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LayoutEntity} from './layout.entity';
import {SystemEntity} from './system.entity';
import {AssetEntity} from './asset.entity';

@EntityTable('layout_system_xref', '0faac292-4136-4f4e-93b1-8bae4f517dce')
export class LayoutSystemXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LayoutEntity, false, false, FieldRelationKind.BELONGS_TO, 'layout', 'aliasId', 'layoutId')
    public layoutId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @JoinColumn(FieldTypeKind.GUID, AssetEntity, true, false, FieldRelationKind.BELONGS_TO, 'faviconAsset', 'aliasId', 'faviconAssetId')
    public faviconAssetId: string;

    @Column(FieldTypeKind.BOOLEAN)
    public default: boolean;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM)
    public environmentKind: EnvironmentKind;

    @Transient()
    public layout: LayoutEntity;

}
